import React, { useEffect, useMemo } from 'react'
import { Container } from '@sencha/ext-modern'
import { useInstData } from 'tyan/public/hooks'

const AnnouncementDetail = props => {
	const { onClose, onRead, showMessage: Message, showBody: Body } = props
	const { me, setState, me: { state: { initValues基本信息 } } } = useInstData(props)

	useEffect(() => {
		const { data: { id } = {} } = props

		if (!id) {
			onClose && onClose()
			return
		}
		Tyan.doPostEvent({
			event: 'GetAnnouncement',
			data: { id, Read: true },
			onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					onClose && onClose()
					return
				}
				// 已读方案1
				setTimeout(() => onRead && onRead())

				setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
			}
		})

		// // 已读方案2
		// return () => {
		// 	me.state.initValues基本信息 && onRead && onRead()
		// }
	}, [])

	if (!initValues基本信息) return <Message text={'请稍等 ...'} />

	const { 附件, 公告标题 } = initValues基本信息
	const fieldsets = [{
		name: '基本信息', _fieldset: [
			{ _label: `<div style='width:100%; height:53px; text-Align:center; color:black; font-Size:24px; padding: 20px 0;font-Weight:600; background:url(resources/logo.png) no-repeat 0 center'>${公告标题}</div>`, minWidth: '95%', margin: null },
			{ _label: "<div style='height:2px; background-color:red;'/>", minWidth: '95%', margin: null },
			{
				_group: '', minWidth: '95%', margin: '0px 0px 0px -20px', items: [
					{ _html: '', name: '公告信息_公告编号', minWidth: '30%', style: { textAlign: 'left', fontSize: '18px', } },
					{ _html: '', name: '公告信息_发布日期', minWidth: '35%', style: { textAlign: 'center', fontSize: '18px', } },
					{ _html: '', name: '公告信息_发布人', minWidth: '30%', style: { textAlign: 'right', fontSize: '18px', } },
				]
			},
			{
				_group: '', minWidth: '95%', margin: '0px 0px 0px -20px', items: [
					{ _html: '', name: '公告信息_等级', minWidth: '30%', style: { textAlign: 'left', fontSize: '18px', } },
					{ _html: '', name: '公告信息_生效日期', minWidth: '35%', style: { textAlign: 'center', fontSize: '18px', } },
					{ _html: '', name: '', minWidth: '30%', style: { textAlign: 'right', fontSize: '18px', } },
				]
			},
			{
				_html: '', name: '公告内容', minWidth: '95%', style: {
					// textAlign: 'center',
					// color: 'black',
					fontSize: '18px',
					lineHeight: 1.4,
					// fontWeight: 600,
				}
			},
			{
				_group: '', minWidth: '95%', margin: '0px 0px 0px -20px', items: [
					{ _html: '', name: '', minWidth: '30%', style: { textAlign: 'left', fontSize: '18px', } },
					{ _html: '', name: '公告信息_公司', minWidth: '65%', style: { textAlign: 'center', fontSize: '18px', } },
				]
			},
			附件 && 附件.length ? { _files: '附件', minWidth: '95%', disabled: true, labelMinWidth: '5em', labelTextAlign: 'right' } : undefined,
		]
	}]

	return <Body data={me} fieldsets={fieldsets} />
}

export default AnnouncementDetail